"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.PowerUpIcon = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_components_1 = __importDefault(require("styled-components"));
var Wrapper = styled_components_1["default"].a(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-decoration: none;\n"], ["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-decoration: none;\n"])));
var Image = styled_components_1["default"].img(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 72px;\n  height: 72px;\n"], ["\n  width: 72px;\n  height: 72px;\n"])));
var Name = styled_components_1["default"].div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 94px;\n  font-style: normal;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 14px;\n\n  text-align: center;\n\n  margin-top: 8px;\n\n  color: #8c85bb;\n"], ["\n  width: 94px;\n  font-style: normal;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 14px;\n\n  text-align: center;\n\n  margin-top: 8px;\n\n  color: #8c85bb;\n"])));
var PowerUpIcon = function (_a) {
    var name = _a.name, iconSrc = _a.iconSrc, idPlugin = _a.idPlugin;
    return ((0, jsx_runtime_1.jsxs)(Wrapper, __assign({ href: "https://trello.com/power-ups/".concat(idPlugin), target: "_blank" }, { children: [(0, jsx_runtime_1.jsx)(Image, { src: "https://tinypowerups.com/images/".concat(iconSrc) }, void 0), (0, jsx_runtime_1.jsx)(Name, { children: name }, void 0)] }), void 0));
};
exports.PowerUpIcon = PowerUpIcon;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=PowerUpIcon.js.map